<vs-dialog [config]="{ dialogContainerClass: 'max-w-[600px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      icon: 'file-x-02',
      iconTheme: 'warn',
      title: config.title,
      subtitle: config.subtitle(claim?.claimNumber ?? '')
    }"
  ></vs-dialog-header>

  <div
    *ngIf="unpaidPayments"
    class="flex gap-3 items-start rounded-xl border border-warn-200 bg-warn-50 px-4 py-3 mb-4"
    data-testid="close-unpaid-payments"
  >
    <vs-icon name="alert-circle" class="text-warn-500 shrink-0 mt-0.5"></vs-icon>
    <div>
      <p class="text-sm font-semibold text-warn-800">{{ config.unpaid.title(unpaidPayments) }}</p>
      <p class="text-sm text-warn-700">{{ config.unpaid.text(unpaidPayments) }}</p>
    </div>
  </div>

  <div class="flex gap-2">
    <button vs-button appearance="outline" class="flex-1" (click)="close()">{{ config.back }}</button>
    <button
      vs-button
      theme="danger"
      class="flex-1"
      [disabled]="unpaidPayments > 0"
      data-testid="confirm-close-claim"
      (click)="confirm()"
    >
      {{ config.confirm }}
    </button>
  </div>
</vs-dialog>
